import { Navigate } from "react-router-dom";
import { useAdminAuth } from "../contexts/AdminAuthContext";
import { useClientAuth } from "../contexts/ClientAuthContext";

const LoadingScreen = () => (
  <div className="min-h-screen bg-[#0A0A0A] flex items-center justify-center">
    <p className="font-heading uppercase tracking-[0.3em] text-sm text-[#A1A1AA]">Loading</p>
  </div>
);

export const ProtectedAdminRoute = ({ children }) => {
  const { admin } = useAdminAuth();
  if (admin === null) return <LoadingScreen />;
  if (admin === false) return <Navigate to="/admin-login" replace />;
  return children;
};

export const ProtectedClientRoute = ({ children }) => {
  const { client } = useClientAuth();
  if (client === null) return <LoadingScreen />;
  if (client === false) return <Navigate to="/portal-login" replace />;
  return children;
};
